<template>
  <div class="element-input element-complete">
    <div class="body">
      <div :class="{ on: true }">
        <img :src="'../static/facebook.event.car.220204.png'" style="width: 55%; margin: auto;" />
      </div>
      <div class="label">{{ data.label }}</div>
      <div class="link" @click="$parent.$parent.doneProcessor('MyInsurance')">신청한 견적서 내역 보러가기<img :src="'../static/chevron_right.png'"/></div>
      <div class="link" @click="$parent.$parent.forceBlockNextStep()">다른 보험 표준 견적서 받아보기<img :src="'../static/chevron_right.png'"/></div>
      
    </div>
  </div>
</template>
<script>
/**
 * 2022-02-04
 * 이벤트 중에 견적신청 완료한경우 보여주는 페이지
 * 
 */
export default {
  props: [ "data", "estimate_id" ,"error" ],
  data() {
    return {
    }
  },
  created () {
    console.log('ECWE - Created!')
    this.$trackingService('init', '001-004-761');
    this.$trackingService('track', 'CompleteRegistration');
  },
  mounted () {
    this.createEventLog()
  },
  methods: {
    createEventLog() {
      this.$store.dispatch( "estimate/createEventLog", {
        customer_id: this.$store.state.customer.profile._id,
        estimate_id: this.estimate_id
      });
    }
  }
}
</script>
